import './VendorList.scss';
import Component from './VendorList.js';
export default Component;